// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { AFS_GRID_FILTER } from 'redux/modules/interferenceAnalysis/constants'
import { pathContainsSubstring } from 'redux/modules/projectSummary/helpers'

const getVisiblePathIds = () => (dispatch, getState) => {
  const {
    form,
    projectSummary,
  } = getState()

  const {
    bandId,
    filterSelect,
    filterInput,
  } = form[AFS_GRID_FILTER].values

  const paths = projectSummary.get('paths')

  // filter the paths based on the assigned band id
  // and filter input/select combination
  return paths.reduce((a, d) => {
    if (
      +bandId === d.get('bandId') &&
      pathContainsSubstring(d, filterSelect, filterInput)
    ) {
      a.push(d.get('pathId'))
    }
    return a
  }, [])
}

export default getVisiblePathIds
